import { render, staticRenderFns } from "./ModalCategoriasEquivalentes.vue?vue&type=template&id=7a75667e"
import script from "./ModalCategoriasEquivalentes.vue?vue&type=script&lang=js"
export * from "./ModalCategoriasEquivalentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports